import type { AiAskFilteredListFields } from '../types';
import type { AiAskIndexData } from './aiAskHelpers';
import { indexLabelForName } from './aiAskHelpers';

export const AI_ASK_ENTITY_LABELS: Record<string, string> = {
  posts: 'Posts',
  members: 'Members',
  organizations: 'Organizations',
  events: 'Events',
  files: 'Files',
  tags: 'Tags',
  rsvps: 'RSVPs',
  groups: 'Groups',
};

export function entityTypeDisplayLabel(
  entityType: string,
  indexData?: AiAskIndexData
): string {
  const logical = entityType.trim().toLowerCase();
  if (AI_ASK_ENTITY_LABELS[logical]) {
    return AI_ASK_ENTITY_LABELS[logical];
  }
  if (indexData && entityType) {
    return indexLabelForName(indexData, entityType);
  }
  return entityType || 'Results';
}

export function parseFilteredListFields(
  raw: Record<string, unknown>
): AiAskFilteredListFields {
  const countRaw = raw.count ?? raw.recordCount;
  const count =
    countRaw == null || countRaw === ''
      ? null
      : Number.isFinite(Number(countRaw))
      ? Number(countRaw)
      : null;

  const filters: Record<string, string> = {};
  if (raw.filters && typeof raw.filters === 'object') {
    Object.entries(raw.filters as Record<string, unknown>).forEach(
      ([key, value]) => {
        if (value != null && String(value).trim()) {
          filters[key] = String(value);
        }
      }
    );
  }

  return {
    responseType:
      typeof raw.responseType === 'string' ? raw.responseType : null,
    queryToken: String(raw.queryToken ?? '').trim(),
    originalQuery: String(
      raw.originalQuery ??
        (raw.debug &&
        typeof raw.debug === 'object' &&
        (raw.debug as Record<string, unknown>).originalQuery) ??
        ''
    ).trim(),
    count,
    entityType: String(raw.entityType ?? '').trim(),
    indexName: String(raw.indexName ?? '').trim(),
    filters,
    queryFilter: Array.isArray(raw.queryFilter) ? raw.queryFilter : [],
    idsTruncated: Boolean(raw.idsTruncated),
    viewResultsError: null,
  };
}
